export { default as CardsPaymentsList } from './CardsPaymentsList';
